// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"cookie-banner-module--cookie-banner--1VdDJ","cookieBanner__body":"cookie-banner-module--cookie-banner__body--3w9VD"};